import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  modalTitle: string = '';
  modalContent: string = '';
  btnSaveLabel: string = 'CONFIRMAR'
  ngOnInit(): void {
    this.modalTitle = this.data.modalTitle ? this.data.modalTitle : '';
    this.modalContent = this.data.modalContent ? this.data.modalContent : '';
    this.btnSaveLabel = this.data.btnSaveLabel ? this.data.btnSaveLabel : 'CONFIRMAR'
  }

  close(): void {
    this.dialogRef.close();
  }

  onPerformAction(): void {
    if (this.data && this.data.onPerformAction) {
      this.data.onPerformAction(this.data.id);
    }
    this.dialogRef.close();
  }
}
